module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmODM4NDFlNWNkYjZjNGEyNjdhNGQ3MjA0YTAwYjdlYi5zdmciOw=="